(function() { window.GUID_2ae30698_13a5_48b7_942c_8ba2197d7d29 = { getGuid: function() { return "2ae30698-13a5-48b7-942c-8ba2197d7d29"; } }; })();


//# sourceMappingURL=IPrepareDataToSendGlobal.js.map
